
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/banking/atb",
      function () {
        return require("private-next-pages/banking/atb.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/banking/atb"])
      });
    }
  